import React, {useContext, useState} from 'react';
import {Container, Row, Col, Button} from 'reactstrap';
// import { NavLink } from 'react-router-dom';
import {gql, useSubscription, useMutation} from '@apollo/client';
import * as Sentry from '@sentry/react'
import useLocalStorage from 'react-use-localstorage';
import {useHistory} from "react-router-dom";

import {InLinePreLoader} from '../components/preloader';
import SidebarQuizUser from '../components/sidebar-quiz-user';
import QuizUserForm from '../components/quiz-user-form';
import {Question, UserPresentationQuizQueryObject} from '../types/quiz'
import {Presentation} from '../types/presentation';
import SideBarBtns from '../components/sidebar-btns';
import {useTimer} from 'use-timer';
import {ReturnValue} from 'use-timer/lib/types';
import EventContext from '../contexts/event';
import UserContext from '../contexts/user';
import LocaleSwitcher from '../components/locale-switcher';
import TopBar from '../components/top-bar';
import QuizResultUserForm from '../components/quiz-result-user-form';
import MobileBottomNav from "../components/mobile-bottom-nav";
import {useIntl} from "react-intl";

// import { Question } from '../types/quiz'

const presentation_subscription = gql`
  # $user_id: uuid!
  subscription presentation_active ($id: String!) {
    presentation_active (
      limit: 1,
      where: {
        id: {
          _eq: $id
        }
      }
    ) {
      event_id
      id

      # live
      # timer

      non_live_questions_active
      non_live_results_active

      # questions_from_time
      # questions_to_time
      # results_from_time
      # results_to_time
      
      questions  (
        where: {
          visible: {
            _eq: true
          }
          
        }
      ) {
        id
        image
        order
        question
        visible
        is_survey
        options {
          id
          option
          order
          correct
        }

        responses {
          options {
            question_option_id
          }
          user_id
          question_id
        }
      }
    }
  }
`

const answer_for_question = gql`
  mutation answer_for_question (
    $question_id: uuid!
    $option_ids: [uuid!]!
    $time: numeric!
  ) {
    answer_for_question(
      question_id: $question_id
      option_ids: $option_ids
      time: $time
    ) {
      id
    }
  }
`
const QuizUser: React.FC<{
    ppt: Presentation;
    locale: string;
    forum?: boolean;
    setLocale: (arg0: string) => void;
}> = ({ppt, locale, setLocale, forum}) => {
    const history = useHistory();

    const eventContext = useContext(EventContext);
    const userContext = useContext(UserContext);
    const [showForumSidebar, setShowForumSidebar] = useState(forum);

    const [currentQuestion, setCurrentQuestion] = useState<Question | null>(null);
    // @ts-ignore
    const [previousTime, setPreviousTime] = useLocalStorage(`quiz-timer-${userContext.user?.id}-${currentQuestion?.id}`, "0");


    const timer = useTimer({
        interval: 100,
        autostart: false,
        step: 0.1,
        initialTime: 0,
        onTimeUpdate: (t) => {
            if (currentQuestion) {
                setPreviousTime(JSON.stringify(t));
            }
        },
    });

    return (
        <>
            <SideBarBtns presentation={ppt}/>
            <div className="grid-contianer quiz-user-container">
                <LocaleSwitcher locale={locale} setLocale={setLocale}/>
                <TopBar
                    presentation={ppt}
                    setShowForumSidebar={setShowForumSidebar}
                    forumIsOpen={false}
                    forum={false}
                    tab={1}
                    hasVideo={ppt.video ? true : false}
                />
                <div className="sidebar">
                    <SidebarQuizUser presentation={ppt} timer={timer} is_survey={currentQuestion?.is_survey}/>
                </div>
                <div className="main c-pad-fix">
                    <Container>
                        <MobileBottomNav presentation={ppt} tab={2}/>
                        <Row >
                            <QuizQuestions
                                ppt={ppt}
                                timer={timer}
                                setCurrentQuestion={setCurrentQuestion}
                            />
                        </Row>
                    </Container>
                </div>
            </div>
        </>
    )
}

const QuizQuestions: React.FC<{
    ppt: Presentation
    timer: ReturnValue;
    setCurrentQuestion: (q: Question | null) => void;
}> = ({ppt, timer, setCurrentQuestion}) => {
    const userContext = useContext(UserContext);
    const intl = useIntl();
    const {
        data: presentationData,
        loading: presentationQueryLoading,
        error: presentationError
    } = useSubscription<UserPresentationQuizQueryObject>(presentation_subscription, {
        variables: {
            id: ppt._id,
            // user_id: userContext.user?.id
        },
        skip: !ppt
    })


    const [submit_answer] = useMutation(answer_for_question, {
        update: (_, {data: {answer_for_question}}) => {
             console.log('debug-xxx : question_response: ', answer_for_question);
          //  window.location.reload();
            setTimeout(() => {
                localStorage.removeItem(`quiz-timer-${userContext.user?.id}-${answer_for_question.id}`)
            }, 2000);
        },
        onError(error) {
             console.log('debug-xxx : question_response: ', error);
        },
    });

    if (presentationQueryLoading  &&  !presentationData /* || userResponsesLoading */) {
        return <InLinePreLoader/>
    }

    if (presentationError) {
         console.log('debug: presentationError: ', presentationError)
        return <i>There was an error</i>
    }
    console.log("presentationData", presentationData);
    
    if (!presentationData || presentationData.presentation_active.length === 0) {
        // TODO
        return <i>The quiz for this presentation is not available yet</i>
    }

    const presentation = presentationData.presentation_active[0];

    if (presentation.live) {
        // TODO
        return <i>Live mode, WIP</i>
    } else {
        const show_quiz = presentation.non_live_questions_active;
        const show_results = presentation.non_live_results_active;

        const {questions} = presentation;

        if (!show_quiz && !show_results) {
            // TODO
            return <i>The quiz for this presentation is not available yet</i>
        }

        if (questions.length === 0) {
             console.log("presentation >>>>", presentation)
            return <i>{intl.formatMessage({id:'quiz.no.questions'})}</i>
        }

        var remaining_questions = questions
            // .filter((question) => userResponsesData.question_response.indexOf((qr: any) => qr.question_id === question.id) === -1)
            // .filter((question) => question.responsesl === 0)
            .sort((a, b) => a.order - b.order);

         console.log("quiz_questions", remaining_questions);
        // filter question based on user
        var quiz_questions: Question[] = [];
        var questionAlreadyAttented = false;
        for (var i = 0; i < questions.length; i++) {
            if (questions[i].responses == undefined || questions[i].responses.length == 0) {
                quiz_questions.push(questions[i]);
                 console.log("quiz_questions", "added");
            } else {
                var alredayAttend = false;
                for (var k = 0; k < questions[i].responses.length; k++) {
                    if (questions[i].responses[k].user_id === userContext.user?.id) {
                        alredayAttend = true;
                        questionAlreadyAttented = true;
                        break;
                    }else{
                        questionAlreadyAttented = false;
                    }
                }
                if (!alredayAttend) {
                     console.log("quiz_questions", "added");
                    quiz_questions.push(questions[i]);
                }

            }
        }

         console.log("quiz_questions", quiz_questions, userContext.user?.id);
        remaining_questions = quiz_questions;


        if (remaining_questions.length === 0) {
            if (show_results) {
                return <Col>{
                    questions
                        .sort((a, b) => a.order - b.order)
                        .map((question, index) => (
                            <QuizResultUserForm
                                key={question.id}
                                question={question}
                                index={index}
                                totalQuestions={questions.length}
                                show_quiz={show_quiz}
                                show_results={show_results}
                                submit_answer={submit_answer}
                                timer={timer}
                            />
                        ))
                }
                </Col>
            } else {
                return <i>{ questionAlreadyAttented ? intl.formatMessage({id:'quiz.no.already.answered'}) : intl.formatMessage({id:'quiz.no.questions'})}</i>
            }
        }

        return <Col>
            {
                [remaining_questions[0]]
                    .map((question, index) => (
                        <QuizUserForm
                            key={question.id}
                            question={question}
                            index={index}
                            totalQuestions={questions.length}
                            show_quiz={show_quiz}
                            show_results={false}
                            submit_answer={submit_answer}
                            timer={timer}
                            setCurrentQuestion={setCurrentQuestion}
                        />
                    ))
            }
        </Col>
    }
}

export default QuizUser;
